import React from "react";
import styles from "./AboutLegal.module.css";

export default function AboutLegal() {
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        {/* Header Card */}
        <section className={styles.headerCard}>
          <div className={styles.badge}>Verification Page</div>
          <h1 className={styles.title}>Legal & Organizational Information</h1>
          <p className={styles.subtitle}>
            This page confirms the nonprofit status and domain ownership of Udyog Connect Corp.
          </p>
        </section>

        {/* Cards Grid */}
        <section className={styles.grid}>
          <article className={styles.card}>
            <h2 className={styles.cardTitle}>Nonprofit Status</h2>
            <p className={styles.cardText}>
              Udyog Connect Corp is a registered nonprofit organization in the United States and is
              recognized as a tax-exempt organization under Section 501(c)(3) of the Internal Revenue Code.
             <strong>Employer Identification Number (EIN): 39-5000156</strong>
            </p>
          </article>
          <article className={styles.card}>
            <h2 className={styles.cardTitle}>Domain Ownership</h2>
            <p className={styles.cardText}>
              The domain <span className={styles.bold}>udyogconnect.org</span> is officially owned, managed,
              and operated by Udyog Connect Corp.
            </p>
          </article>

          <article className={styles.cardWide}>
            <h2 className={styles.cardTitle}>Official Statement</h2>
            <p className={styles.cardText}>
              Udyog Connect Corp provides services and information through the udyogconnect.org domain for
              community and nonprofit purposes consistent with its mission.
            </p>
            <div className={styles.metaRow}>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Organization</span>
                <span className={styles.metaValue}>Udyog Connect Corp</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Domain</span>
                <span className={styles.metaValue}>udyogconnect.org</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Category</span>
                <span className={styles.metaValue}>501(c)(3) Nonprofit</span>
              </div>
            </div>
          </article>
        </section>

        {/* Footer Note */}
        <section className={styles.note}>
          <p className={styles.noteText}>
            If you require additional verification details, please contact{" "}
            <a className={styles.link} href="mailto:info@udyogconnect.org">
              info@udyogconnect.org
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}